import { create } from "zustand";

type State = {
	showOnboarding: boolean;
};

type Actions = {
	setShowOnboarding: (value: boolean) => void;
};

type Store = State & Actions;

export const useOnboardingStore = create<Store>((set) => ({
	showOnboarding: false,
	setShowOnboarding: (value) => set({ showOnboarding: value }),
}));
